import http from "./httpService";

const apiEndpoint = "/services/app/User";

export function changePassword(newPassword) {
  return http.post(apiEndpoint + "/ChangePassword", newPassword);
}
